import React, { Component } from "react";
import { Layout, BackTop, Spin, Tooltip, Space } from "antd";
import { FormattedMessage } from "react-intl";

import Topmenu from "../../components/menu/topmenu";
import { config, siteConfig } from "../../settings/config";
import TopbarViewWrapper from "./topbar.style";

import { withTheme } from "styled-components";

import Nprogress from "nprogress";
import ErrorBoundary from "../../helpers/errorBoundary";
import AppContext from "../../AppContext";

const { Content, Footer } = Layout;

export class TopbarView extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  componentWillUnmount() {
    Nprogress.start();
  }

  async componentDidMount() {
    if (!this.props.layout && this.context.appLayout !== "topbar") {
      await this.context.updateLayout("topbar");
    }
    Nprogress.done();
  }

  render() {
    return this.props.layout ? (
      <Spin spinning={this.state.isLoading}>
        <TopbarViewWrapper>
          <Layout id="main-layout" className="topbarViewContainer">
            {this.context.getBanner()}
            <BackTop />
            <Layout className="topbarViewLayout">
              <Topmenu />
              <Layout id="content-main-layout" className="topbarViewContentLayout">
                <BackTop target={() => document.getElementById("content-main-layout")} />
                <Content id="content-main" className="topbarViewContent antSpinFillParent">
                  <ErrorBoundary>{this.props.children}</ErrorBoundary>
                  <Footer className="topbarViewContentFooter">
                    <Tooltip
                      title={
                        <span>
                          <FormattedMessage id={config.fef_ui_version ? "Version" : "Unknown Version"} />{config.fef_ui_version ? ` ${config.fef_ui_version}` : ""}
                        </span>
                      } 
                      trigger={["hover", "click"]}
                    >
                      <Space>
                        <FormattedMessage id={siteConfig.footerText} />
                      </Space>
                    </Tooltip>
                  </Footer>
                </Content>
              </Layout>
            </Layout>
          </Layout>
        </TopbarViewWrapper>
      </Spin>
    ) : (
      this.props.children
    );
  }
}

export default withTheme(TopbarView);
